<template>
    <div class="tech-chart-card">
        <div class="tech-chart-card__header">
            <div>
                <p class="tech-chart-card__eyebrow">Utilization</p>
                <h3 class="tech-chart-card__title">Device status</h3>
            </div>
        </div>
        <div v-if="hasData" class="tech-chart-card__body">
            <apexchart type="bar" height="320" :options="chartOptions" :series="series"></apexchart>
        </div>
        <div v-else class="tech-chart-card__empty">No utilization data for this period.</div>
    </div>
</template>

<script>
export default {
    name: "UtilizationStatusChart",
    props: {
        categories: {
            type: Array,
            default: function () {
                return [];
            },
        },
        inUse: {
            type: Array,
            default: function () {
                return [];
            },
        },
        inStock: {
            type: Array,
            default: function () {
                return [];
            },
        },
    },
    computed: {
        hasData: function () {
            var useVals = Array.isArray(this.inUse) ? this.inUse : [];
            var stockVals = Array.isArray(this.inStock) ? this.inStock : [];
            return useVals.concat(stockVals).some(function (v) {
                return Number(v) > 0;
            });
        },
        series: function () {
            return [
                {
                    name: "In Use",
                    data: Array.isArray(this.inUse) ? this.inUse : [],
                },
                {
                    name: "In Stock",
                    data: Array.isArray(this.inStock) ? this.inStock : [],
                },
            ];
        },
        chartOptions: function () {
            return {
                chart: {
                    type: "bar",
                    stacked: true,
                    stackType: "100%",
                    toolbar: { show: false },
                    fontFamily: "inherit",
                    parentHeightOffset: 0,
                    offsetX: 0,
                    animations: {
                        enabled: true,
                        easing: "easeinout",
                        speed: 650,
                    },
                },
                plotOptions: {
                    bar: {
                        horizontal: true,
                        borderRadius: 6,
                        barHeight: "62%",
                    },
                },
                colors: ["#0f766e", "#94a3b8"],
                dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                        if (!val || val < 8) return "";
                        return Math.round(val) + "%";
                    },
                    style: {
                        fontSize: "11px",
                        fontWeight: 700,
                        colors: ["#ffffff"],
                    },
                },
                stroke: {
                    width: 2,
                    colors: ["#ffffff"],
                },
                grid: {
                    borderColor: "#e2e8f0",
                    strokeDashArray: 4,
                    xaxis: { lines: { show: true } },
                    yaxis: { lines: { show: false } },
                    padding: { top: 0, right: 8, bottom: 4, left: 12 },
                },
                xaxis: {
                    categories: Array.isArray(this.categories) ? this.categories : [],
                    max: 100,
                    tickAmount: 4,
                    labels: {
                        style: {
                            colors: "#94a3b8",
                            fontSize: "11px",
                        },
                        formatter: function (val) {
                            return Math.round(Number(val)) + "%";
                        },
                    },
                    axisBorder: { show: false },
                    axisTicks: { show: false },
                },
                yaxis: {
                    labels: {
                        show: true,
                        align: "left",
                        minWidth: 72,
                        maxWidth: 90,
                        trim: false,
                        hideOverlappingLabels: false,
                        style: {
                            colors: "#475569",
                            fontSize: "12px",
                            fontWeight: 600,
                        },
                    },
                },
                legend: {
                    position: "top",
                    horizontalAlign: "left",
                    fontSize: "12px",
                    fontWeight: 600,
                    markers: {
                        width: 10,
                        height: 10,
                        radius: 10,
                    },
                },
                tooltip: {
                    shared: true,
                    intersect: false,
                    theme: "light",
                    y: {
                        formatter: function (val) {
                            return val + " items";
                        },
                    },
                },
            };
        },
    },
};
</script>

<style lang="scss" scoped>
@import "./chart-card.scss";

.tech-chart-card__body {
    overflow: visible;
}

.tech-chart-card__body :deep(.apexcharts-canvas),
.tech-chart-card__body :deep(svg) {
    overflow: visible !important;
}
</style>
